{
  "customer-register-dialog": {
    "buttons": {
      "cancel": "Annuler",
      "next": "Suivant"
    },
    "text": {
      "book_as_guest": "Réserver en tant qu'invité",
      "login": "vous connecter",
      "or": " ou ",
      "register": "vous inscrire",
      "to_manage": "Pour gérer toutes vos réservations et vos salons préférés, veuillez "
    }
  }
}
